enum BIEventType {

    ViewLoaded = "View loaded",

    DepositAttempt = "DepositAttempt",
    DepositFailedUI = "Deposit Failed UI",
    DepositFieldCompletion = "Deposit Form Field Completion",
    DepositPaymentMethodsSliderForward = "Deposit Methods Slider forward",
    DepositPaymentMethodChange = "Deposit Payment Method Change",
    DepositCurrencyChange = "Deposit Currency Change",
    DepositApplyDiscountClick = "Deposit Apply discount click",
}

export {
    BIEventType
};
